import Header from "./shared/Header/Header";
import { PageNotFound } from "./components/PageNotFound/PageNotFound";
import Contact from "./components/Contact/Contact";
import Overview from "./components/DocumentationSections/Overview/Overview";
import { NAVIGATE_TO, BASE_NAME } from "./constants/FileConstants";
import {
  BrowserRouter as Router,
  Route,
  Navigate,
  Routes,
} from "react-router-dom";
import "./App.css";
import Documentation from "./components/Documentation/Documentation";
import SideBar from "./components/Documentation/SideBar/SideBar";
import "./styles/main.scss";
import SupportedResourcesDetails from "./components/DocumentationSections/SupportedCapabilities/SupportedResources/SupportedResourcesDetails/SupportedResourcesDetails";
import SupportedSystemOperationsDetials from "./components/DocumentationSections/SupportedCapabilities/SupportedSystemOperations/SystemOperationsDetials/SystemOperationsDetials";
import ImportMappingDetails from "./components/DocumentationSections/Mappings/Import/ImportMappingDetails/ImportMappingDetails";
import EHCMappingDetails from "./components/DocumentationSections/Mappings/EHConcept/EHCMappingDetails/EHCMappingDetails";
import Spinner from "./shared/Spinner/Spinner";
import SnackBar from "./shared/SnackBar/SnackBar";
import GlobalDataContext from "./shared/GlobalContext/GlobalDataContext";
import { useState, useEffect } from "react";
import ApiDataService from "./services/ApiDataService";

// @name App
// @desc Routings configuration and initial setup
// @author Sahithi
function App() {
  const [metaData, setMetaData] = useState(new Map());
  const [loadSpinner, setLoadSpinner] = useState(true);
  const [loadSnackBar, setLoadSnackBar] = useState(false);
  const [snackBarDetials, setSnackBarDetials] = useState();

  useEffect(() => {
    if(metaData.size === 0){
     getAllJsonMetaData();
    }
  }, [metaData]);

  const getAllJsonMetaData = () => {
    setLoadSpinner(true);
    ApiDataService.getAllMetadata()
      .then((response) => {
        setLoadSpinner(false);
        if (response.data.status === "success") {
          //console.log(response);
          const res = response.data.data;
          let map = new Map();
          if (res.length > 0) {
            res.forEach((e) => {
              map.set(e.titleText, e.jsonText);
            });
          }
          setMetaData(map);
        }
      })
      .catch((err) => {
        setLoadSpinner(false);
        setLoadSnackBar(true);
        setSnackBarDetials({
          message: `${err?.response?.data?.error_description || err?.message}`,
          severity: "error",
        });
        setTimeout(() => {
          setLoadSnackBar(false);
        }, 5000);
      });
  };

  return (
    <>
      <GlobalDataContext.Provider value={{ metaData ,setMetaData}}>
        <Router basename={BASE_NAME.slice(1)}>
          <Header />
          <Routes>
            <Route
              path="/"
              element={<Navigate to={NAVIGATE_TO.DOCUMENTATION} replace />}
            />
            <Route
              path={NAVIGATE_TO.DOCUMENTATION}
              element={<Documentation />}
            />
            {/* <Route path={NAVIGATE_TO.CONTACT} element={<Container>< Contact /></Container>} /> */}
            <Route
              path={`${NAVIGATE_TO.DOCUMENTATION}${NAVIGATE_TO.SUPPORTED_RESOURCES_DETAILS}`}
              element={<SupportedResourcesDetails />}
            />
            <Route
              path={`${NAVIGATE_TO.DOCUMENTATION}${NAVIGATE_TO.SUPPORTED_SYSTEM_OPERATIONS}`}
              element={<SupportedSystemOperationsDetials />}
            />
            <Route
              path={`${NAVIGATE_TO.DOCUMENTATION}${NAVIGATE_TO.IMPORT_MAPPING}`}
              element={<ImportMappingDetails />}
            />
            <Route
              path={`${NAVIGATE_TO.DOCUMENTATION}${NAVIGATE_TO.EHC_MAPPING}`}
              element={<EHCMappingDetails />}
            />
            <Route
              path={NAVIGATE_TO.PAGE_NOT_FOUND}
              element={<PageNotFound />}
            />
            <Route
              path="*"
              element={<Navigate to={NAVIGATE_TO.PAGE_NOT_FOUND} replace />}
            />
          </Routes>
        </Router>
        {/* Loading spinner */}
        {loadSpinner && <Spinner />}
        {/* Snackbar to display notifications */}
        {loadSnackBar && (
          <SnackBar
            open={loadSnackBar ? true : false}
            message={snackBarDetials.message}
            severity={snackBarDetials.severity}
          />
        )}
      </GlobalDataContext.Provider>
    </>
  );
}

export default App;
